import { withInstall } from '@vuesax-alpha/utils'
import Col from './src/col.vue'

export const VsCol = withInstall(Col)
export default VsCol

export * from './src/col'
